@if (isInBrowser) {
<div class="flex flex-row justify-center bg-e-white">
  <app-cms-page class="w-full" storyUrl="general/global-message"></app-cms-page>
</div>
}
<div class="bg-e-white min-h-[4.625rem] z-[100] border-b border-[#a6a6a6] md:border-[rgba(0,0,0,0.5)] sticky top-0 flex flex-col w-full justify-center">
  <div class="flex px-[1.5rem] sm:px-[2.5rem] max-w-[90rem] mx-auto w-full">
    <div class="basis-[25%] flex">
      <button (click)="toggleDrawer()">
        <img src="/assets/images/icons/hamburger.svg" width="30" height="21" alt="menu hamburger" />
      </button>
    </div>

    <div class="basis-[50%] flex justify-center text-center px-[0.5rem]">
      <ng-template #logoContent>
        <img height="28" width="139" alt="Ekomenu logo" class="w-[139px] mx-auto" [src]="env.logo" />
        <span class="block text-e-dark-green font-sans text-[0.5625rem] pl-[0.4rem] tracking-[0.1rem] font-medium uppercase whitespace-nowrap">{{ env.subtitle | translate }}</span>
      </ng-template>

      @if(show_userbuttons){
      <a class="no-underline" routerLink="/" aria-label="Homepage">
        <ng-container *ngTemplateOutlet="logoContent"></ng-container>
      </a>
      }@else{
      <div>
        <ng-container *ngTemplateOutlet="logoContent"></ng-container>
      </div>
      }
    </div>

    <div class="basis-[25%] flex flex-wrap content-center items-center justify-end">
      <ng-template #accountIconButton let-route="route" let-buttonId="id">
        <a [routerLink]="route" class="rounded-full flex flex-col items-center justify-center h-[2.25rem] w-[2.25rem]" [id]="buttonId" aria-label="User" [ngClass]="{
            'bg-e-dark-green': router.isActive(route, false),
            'bg-white': !router.isActive(route, false)
          }">
          <img src="/assets/images/icons/account{{
              router.url.startsWith('/user/') ? '_white' : ''
            }}.svg" width="18" height="18" alt="user profile" />
        </a>
      </ng-template>

      <div class="grid-cols-[1fr] grid grid-flow-col-dense gap-[0.5rem]">

        <div class="relative" cdkOverlayOrigin #languageTrigger="cdkOverlayOrigin">
          <div class="bg-white rounded-full flex flex-col items-center justify-center h-[2.25rem] w-[2.25rem] cursor-pointer" (click)="toggleLanguageOverlay()">
            <img [src]="'./assets/images/icons/lang_' + (preferredlanguageForm.value?.toLowerCase() || 'nl') + '.svg'" alt="language" height="20" width="20" />
          </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="languageTrigger" [cdkConnectedOverlayOpen]="showLanguageOverlay" [cdkConnectedOverlayHasBackdrop]="true"
          (backdropClick)="showLanguageOverlay = false" [cdkConnectedOverlayBackdropClass]="'opacity-0'" [cdkConnectedOverlayPanelClass]="'rounded-lg'"
          [cdkConnectedOverlayOffsetY]="8">
          @if (showLanguageOverlay) {
          <div class="text-e-dark-green z-10 left-0 top-9 rounded-xl bg-white drop-shadow-md min-w-[120px]">
            @for (code of languages; track $index) {
            <div class="flex flex-row items-center justify-between rounded-lg px-3 py-2 hover:bg-e-dark-green hover:text-white cursor-pointer" [ngClass]="{
                    'bg-e-dark-green text-white': preferredlanguageForm.value === code
                  }" (click)="selectLanguage(code)" id="language-{{code}}">
              <img [src]="'./assets/images/icons/lang_' + code.toLowerCase() + '.svg'" alt="language" height="20" width="20" class="me-2" />
              <span class="text-sm font-light">{{ 'language.' + code | translate }}</span>
            </div>
            }
          </div>
          }
        </ng-template>

        @if (orderlines?.controls.length >0 && !is_in_cart) {
        <a routerLink="{{ 'singleorder.organicwebshop_url' | translate }}"
          class="bg-white block rounded-full flex flex-col items-center justify-center h-[2.25rem] w-[2.25rem] relative" [ngClass]="{
              'bg-e-dark-green': router.url.includes('/checkout')
            }" id="checkout" aria-label="Checkout">
          <img [src]="router.url.includes('/checkout') ? './assets/images/icons/cart-white.png' : './assets/images/icons/cart.png'" alt="cart" height="18" width="18" />
        </a>
        }

        @if (show_userbuttons) {
        @if (isAuthenticated | async) {
        @if (currentUser?.customerid && !router.url.includes('/recipefirst')) {
        <a class="rounded-full flex flex-col items-center justify-center h-[2.25rem] w-[2.25rem]" routerLink="/user" queryParamsHandling="merge" id="user" [ngClass]="{
                  'bg-e-dark-green': router.url.startsWith('/user') && !router.url.startsWith('/user/'),
                  'bg-white': !(router.url.startsWith('/user') && !router.url.startsWith('/user/'))
                }">
          <img src="./assets/images/icons/calendar_temp{{
                    router.url.startsWith('/user') && !router.url.startsWith('/user/')
                      ? '_white'
                      : ''
                  }}.png" alt="calendar" height="25" width="25" />
        </a>
        }
        @if (currentUser?.customerid) {
        <ng-container *ngTemplateOutlet="
                  accountIconButton;
                  context: { route: '/user/settings', id: 'settings' }
                "></ng-container>
        }
        } @else {
        <ng-container *ngTemplateOutlet="
                accountIconButton;
                context: { route: '/user', id: 'user' }
              "></ng-container>
        }
        }
      </div>
    </div>
  </div>
</div>
